import { Link } from "react-router-dom";
import Seo from "@/components/Seo";
import { Button } from "@/components/ui/button";

export default function NotFound() {
  return (
    <div className="mx-auto max-w-2xl px-4 py-24 text-center sm:px-6 lg:px-8">
      <Seo title="Page not found | CA HVAC Direct" description="The page you're looking for doesn't exist." />
      <p className="font-heading text-6xl font-black tracking-tight text-sky-700">404</p>
      <h1 className="mt-4 font-heading text-3xl font-black tracking-tight text-slate-900">Page not found</h1>
      <p className="mt-3 text-slate-600">The page you're looking for doesn't exist or has moved.</p>
      <div className="mt-8 flex justify-center gap-3">
        <Button asChild className="rounded-sm bg-sky-700 hover:bg-sky-800"><Link to="/">Go Home</Link></Button>
        <Button asChild variant="outline" className="rounded-sm border-slate-300"><Link to="/shop">Shop Equipment</Link></Button>
      </div>
    </div>
  );
}
